import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { metricDefs, isMetricSeriesAvailable } from '../metric-defs';
import type { ScalarMetricKey } from '@/types/analyticsV2';

interface ChartMetricSelectorProps {
  value: ScalarMetricKey;
  onChange: (key: ScalarMetricKey) => void;
}

/**
 * The trend chart's metric switcher, styled to read as part of the chart
 * heading ("<MetricName> Trend"). Trigger has no border / no bg so it sits
 * inline with the title text; the shadcn `Select` chevron stays as the
 * affordance.
 */
export function ChartMetricSelector({ value, onChange }: ChartMetricSelectorProps) {
  const options = Object.values(metricDefs).filter((d) => isMetricSeriesAvailable(d.key));

  return (
    <Select value={value} onValueChange={(v) => onChange(v as ScalarMetricKey)}>
      <SelectTrigger
        size='sm'
        className='w-auto gap-2 rounded-full border border-gray-500 bg-white pl-3 pr-2.5 py-1 text-[13px] leading-[18px] font-normal focus:ring-0 focus:ring-offset-0 h-[28px]!'
      >
        <span className='inline-flex items-baseline gap-1'>
          <SelectValue />
          <span>Trend</span>
        </span>
      </SelectTrigger>
      <SelectContent>
        {options.map((d) => (
          <SelectItem key={d.key} value={d.key}>
            {d.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
